﻿import { Component, OnInit } from "@angular/core";
import { DashboardService } from "../../../service/api/builk/dashboard.service";
import { DashboardInfoModel } from "../../../model/builk/dashboard/dashboard-info.model";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "bo-builk-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.scss"]
})

export class DashboardComponent implements OnInit {
  info: DashboardInfoModel;
  isLoading: boolean = true;
  isError: boolean = false;
  isNow: boolean = true;
  isCustom: boolean = false;
  tab: string = 'now';

  periodDate: Array<Date> = [];

  constructor(
    private dashboardService: DashboardService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['tab'] != undefined && params['tab'] != null && (params['tab'] == 'now' || params['tab'] == 'custom')) {
        this.tab = params['tab'];
      }
  });
  }

  ngOnInit() {
    if (this.tab == 'custom') {
      this.isNow = false;
      this.isCustom = true;
      this.periodDate = [];
      let dateTime = new Date();
      this.periodDate.push(new Date(dateTime.getFullYear(), dateTime.getMonth(), 1))
      this.periodDate.push(new Date(dateTime.getFullYear(), dateTime.getMonth() + 1, 0))
      this.getPeriodDashboardInfo();
    } else {
      this.isNow = true;
      this.isCustom = false;
      this.getDashboardInfo();
    }
  }

  getDashboardInfo(): void {
    this.isLoading = true;
    this.dashboardService.getDashboardInfo().subscribe(
      response => {
        this.info = response;
        this.isLoading = false;
      },
      err => {
        // unauthorized refresh token
        console.log("Can't Get Dashboard Info");
        this.isError = true;
      }
    );
  }

  getPeriodDashboardInfo(): void {
    this.isLoading = true;
    this.dashboardService.getPeriodDashboardInfo(this.periodDate[0], this.periodDate[1]).subscribe(
      response => {
        this.info = response;
        this.isLoading = false;
      },
      err => {
        // unauthorized refresh token
        console.log("Can't Get Dashboard Info");
        this.isError = true;
      }
    );
  }

  onBtnCustom(val: boolean) {
    this.isCustom = val;
    if (this.isCustom == false) {
      this.isNow = true;
      this.isCustom = false;
      this.router.navigate([],
        {
          relativeTo: this.activatedRoute,
          queryParams: { tab: 'now' },
          queryParamsHandling: 'merge',
        }
      );
      this.getDashboardInfo();
    } else {
      this.isNow = false;
      this.isCustom = true;
      this.router.navigate([],
        {
          relativeTo: this.activatedRoute,
          queryParams: { tab: 'custom' },
          queryParamsHandling: 'merge',
        }
      );
      if (this.periodDate.length == 0) {
        this.periodDate = [];
        let dateTime = new Date();
        this.periodDate.push(new Date(dateTime.getFullYear(), dateTime.getMonth(), 1))
        this.periodDate.push(new Date(dateTime.getFullYear(), dateTime.getMonth() + 1, 0))
      }
      this.getPeriodDashboardInfo();
    }
  }

  onDateChange() {
    if (this.isCustom) {
      this.isNow = false;
      this.getPeriodDashboardInfo();
    } else {
      this.isNow = true;
      this.getDashboardInfo();
    }
  }
}
